<template>
  <div align="center" class="menu-wrapper pt-5 pl-1 pr-1">

    <VerifyTyc />
    <div class="pb-5" v-if="$store.state.tyc === 1">
      <verifyPromo />
    </div>

    <FreespinTar v-model="modalFreespin" :cantidad-spins="10" juego="Nuevo Casino Tarplay"
      ruta-juego="/gamep/TarPlay/vs5trdragons" />

    <MaintenanceModal v-model="showMaintenance" />



    <!-- =========================
         DESKTOP (size > 960)
         Izquierda: destacado (2 filas)
         Derecha: 3 columnas (md=4)
         ========================= -->
    <v-row justify="center" class="centrar" v-if="size > 960">
      <!-- Destacado (izquierda) -->
      <v-col cols="12" md="3" lg="3" xl="3" class="card-col-large" v-if="featuredBig">
        <div class="card-h featured-card" @click="$router.push(featuredBig.link)">
          <v-img style="border-radius: 6px" class="featured-img" contain :src="featuredBig.img" />
        </div>
      </v-col>

      <!-- Derecha: 3 columnas -->
      <v-col cols="12" md="8" lg="8" xl="8" class="card-col-large">
        <v-row>
          <v-col v-for="(item, index) in otherBigButtonsVisible" :key="'big-other-' + index" cols="12" sm="4" md="4"
            class="card-col-large">
            <div class="card-h" @click="$router.push(item.link)">
              <v-img style="border-radius: 6px" :max-height="largeCardHeight" contain :src="item.img" />
            </div>
          </v-col>

          <v-col cols="12" v-if="showLoadMoreRight">
            <v-btn @click="showAll = true" color="primary">Ver más opciones</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- =========================
         MOBILE (<= 960)
         2 columnas:
         - Col 1: destacado (doble alto) + resto alternando
         - Col 2: SOLO 2 botones al lado del destacado (cada uno = alto normal)
                  resto debajo del destacado
         ========================= -->
    <v-row justify="center" class="centrar-mobile" v-else>
      <!-- Columna izquierda -->
      <v-col cols="6" class="mt-0 pt-0">
        <!-- Destacado -->
        <div v-if="featuredSmall" class="card-h featured-card-mobile" @click="$router.push(featuredSmall.link)">
          <v-img style="border-radius: 6px" class="featured-img" contain :src="featuredSmall.img" />
        </div>

        <!-- Debajo del destacado: continúa normal (columna 1) -->
        <div v-for="(item, index) in smallCol1" :key="'small-col1-' + index" class="card-h mt-2"
          @click="handleSmallClick(item, $event)">
          <v-img style="border-radius: 6px" :max-height="smallCardHeight" contain :src="item.img" />
        </div>
      </v-col>

      <!-- Columna derecha -->
      <v-col cols="6" class="mt-0 pt-0">
        <!-- BLOQUE SUPERIOR: misma altura exacta del destacado, SOLO 2 botones -->
        <div class="mobile-right-top" v-if="smallCol2Top.length">
          <div v-for="(item, index) in smallCol2Top" :key="'small-col2top-' + index" class="card-h mobile-half"
            @click="handleSmallClick(item, $event)">
            <v-img style="border-radius: 6px" class="mobile-half-img" contain :src="item.img" />
          </div>
        </div>

        <!-- El resto arranca JUSTO debajo del destacado -->
        <div v-for="(item, index) in smallCol2" :key="'small-col2-' + index" class="card-h mt-2"
          @click="handleSmallClick(item, $event)">
          <v-img style="border-radius: 6px" :max-height="smallCardHeight" contain :src="item.img" />
        </div>
      </v-col>
    </v-row>

    <!-- Modal bancamiga -->
    <template v-if="$store.state.idmoneda === 0">
      <v-row justify="center">
        <!-- modal comentado -->
      </v-row>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import verifyPromo from "../components/VerifyPromo.vue";
import VerifyTyc from "../components/VerifyTyc.vue";
import MaintenanceModal from "../components/MaintenanceModal.vue";
import FreespinTar from "../components/FreespinTar.vue";

export default {
  components: {
    verifyPromo,
    VerifyTyc,
    MaintenanceModal,
    FreespinTar,
  },
  data() {
    return {
      gameUrl: null,
      overlay: true,
      showMaintenance: true,
      modalFreespin: false,
      loading: false,
      isMobile: 0,
      link: "/inh",
      dialogm1: 0,
      dialog: true,
      dialogPreg: false,
      bancamiga: true,
      showAll: false,

      bigButtons: [
        { img: "https://trackandraces.com/dominio/tr/menu/btntarplayw.png", link: "/casinotar", condition: true },
        { img: "https://trackandraces.com/dominio/tr/menu/btninterweb.png", link: "/inh", condition: true },
        { img: "https://trackandraces.com/dominio/tr/menu/mparleypc.png", link: "/sport", condition: true },
        { img: "https://trackandraces.com/dominio/tr/menu/puestosweb.png", link: "/puestos", condition: this.$store.state.idmoneda <= 2 },
        /* { img: "https://trackandraces.com/dominio/tr/menu/btnslots.png", link: "/casino", condition: (this.$store.state.idsb == 8 || this.$store.state.idsb == 13) }, */
        /* { img: "https://trackandraces.com/dominio/tr/menu/btncasinovivo.png", link: "/gamep/livecasino/101", condition: (this.$store.state.idsb == 8 || this.$store.state.idsb == 13) }, */
        { img: "https://trackandraces.com/dominio/tr/menu/m247pc.png", link: "/virtuales/dog8", condition: true },
         { img: "https://trackandraces.com/dominio/tr/menu/btnnacweb.png", link: "/nacionales", condition: this.$store.state.idmoneda == 1 }, 
        { img: "https://trackandraces.com/dominio/tr/menu/macuareweb.png", link: "/macuare", condition: true },
        /* { img: "https://trackandraces.com/dominio/tr/menu/btnpokerweb.png", link: "/evenbet", condition: (this.$store.state.idsb == 8 || this.$store.state.idsb == 13) }, */

      ],

      smallButtons: [
        { img: "https://trackandraces.com/dominio/tr/menu/btntarplaym.png", link: "/casinotar", condition: true },
        { img: "https://trackandraces.com/dominio/tr/menu/mm/internacionalesmm.png", link: "/inh", condition: true },
        { img: "https://trackandraces.com/dominio/tr/menu/mm/parleymm.png", link: "/sport", condition: true },
        /* { img: "https://trackandraces.com/dominio/tr/menu/mm/slotsmm.png", link: "/casino", condition: (this.$store.state.idsb == 8 || this.$store.state.idsb == 13) },
        { img: "https://trackandraces.com/dominio/tr/menu/mm/casinomm.png", link: "/gamep/livecasino/101", condition: (this.$store.state.idsb == 8 || this.$store.state.idsb == 13) }, */
         { img: "https://trackandraces.com/dominio/tr/menu/mm/nacionalesmm.png", link: "/nacionales", condition: this.$store.state.idmoneda == 1 },
        { img: "https://trackandraces.com/dominio/tr/menu/puestosmovil.png", link: "/puestos", condition: this.$store.state.idmoneda <= 2 },
        { img: "https://trackandraces.com/dominio/tr/menu/mm/diversionmm.png", link: "/virtuales/dog8", condition: true },
        { img: "https://trackandraces.com/dominio/tr/menu/mm/macuaremm.png", link: "/macuare", condition: true },
        /*  { img: "https://trackandraces.com/dominio/tr/menu/mm/pokermm.png", link: "/evenbet", condition: (this.$store.state.idsb == 8 || this.$store.state.idsb == 13) }, */
      ],
    };
  },

  async created() {
    this.$store.state.pais_user = sessionStorage.getItem("pais_user");
    await axios.post("details").then((response) => {
      this.$store.state.idpromodia = response.data.promodia.promo;
      this.$store.state.nbpromodia = response.data.promodia.nbpromo;
    });
  },

  mounted() {
    this.getLink();
    this.getSaldo();
    this.abrirModalFreeSpin();
  },

  methods: {
    ...mapActions(["getSaldo"]),
    getLink() {
      this.link = "/bet";
    },
    handleSmallClick(item, event) {
      if (item.stop) event.stopPropagation();
      this.$router.push(item.link);
    },
    async abrirModalFreeSpin() {
      let bono = "";
      if (this.$store.state.promocode == "")
        this.modalFreespin = false;
      else {
        await axios.post("pragmaticbono/check").then((response) => {
          bono = response.data.message;
        });
        if(bono!=="Activo")
          this.modalFreespin = true;
      }
    },
  },

  computed: {
    size() {
      return this.$store.state.windowSize.x;
    },

    filteredBigButtons() {
      return this.bigButtons.filter((item) => item.condition);
    },
    filteredSmallButtons() {
      return this.smallButtons.filter((item) => item.condition);
    },

    // ===== DESKTOP =====
    featuredBig() {
      return this.filteredBigButtons.find((b) => b.img && b.img.includes("btntarplayw.png")) || null;
    },
    otherBigButtons() {
      return this.filteredBigButtons.filter((b) => !(b.img && b.img.includes("btntarplayw.png")));
    },
    otherBigButtonsVisible() {
      if (this.showAll) return this.otherBigButtons;
      return this.otherBigButtons.slice(0, 12);
    },
    showLoadMoreRight() {
      return !this.showAll && this.otherBigButtons.length > 12;
    },

    // ===== MOBILE =====
    featuredSmall() {
      return this.filteredSmallButtons.find((b) => b.img && b.img.includes("btntarplaym.png")) || null;
    },
    otherSmallButtons() {
      return this.filteredSmallButtons.filter((b) => !(b.img && b.img.includes("btntarplaym.png")));
    },

    // SOLO 2 botones al lado del destacado
    smallCol2Top() {
      return this.otherSmallButtons.slice(0, 2);
    },

    // Resto arranca debajo del destacado, alternando columnas
    smallRemainder() {
      return this.otherSmallButtons.slice(2);
    },
    smallCol1() {
      return this.smallRemainder.filter((_, i) => i % 2 === 0);
    },
    smallCol2() {
      return this.smallRemainder.filter((_, i) => i % 2 === 1);
    },

    largeCardHeight() {
      return "calc(50vh - 100px)";
    },
    smallCardHeight() {
      // Puedes cambiar SOLO este valor (una vez) y todo se mantiene proporcional
      return "var(--mob-card-h)";
    },
  },
};
</script>

<style>
.card-h:hover {
  filter: grayscale(0.5);
  cursor: pointer;
  transition: ease-in-out 250ms;
  transform: scale(0.95);
}

.card-h {
  filter: none;
}

/* Desktop: tu estilo original */
.centrar {
  display: flex;
  align-items: center;
}

/* Mobile: alineamos arriba */
.centrar-mobile {
  align-items: flex-start;
}

/* Ajuste para que no tape el header "Mi perfil" en móvil */
@media (max-width: 960px) {
  .menu-wrapper {
    padding-top: 16px;
  }
}

/* Estilos específicos para pantallas grandes */
@media (min-width: 960px) {
  .card-col-large {
    padding: 8px !important;
  }

  .card-h {
    max-width: 500px;
    margin: 0 auto;
  }

  .v-image {
    transform: scale(1.03);
    transition: transform 0.3s ease;
  }

  .v-image:hover {
    transform: scale(1);
  }
}

/* =========================
   DESTACADO DESKTOP (doble alto)
   ========================= */
@media (min-width: 960px) {
  .featured-card {
    height: calc((50vh - 100px) * 2 + 16px);
    max-width: 500px;
    margin: 0 auto;
  }

  .featured-card .v-image,
  .featured-img {
    height: 100% !important;
  }
}

/* =========================
   MOBILE (estable en todos)
   - UNA sola fuente de verdad: --mob-card-h
   ========================= */
@media (max-width: 960px) {

  /* ✅ Ajusta SOLO este valor para todos los teléfonos.
     - dvh es más estable en móviles modernos
     - fallback: si no soporta dvh, usará vh.
  */
  :root {
    --mob-gap: 2px;
    --mob-card-h: calc(15dvh);
    /* <- cambia este número si quieres más grande/pequeño */
    /* fallback (si algún navegador no soporta dvh, igual suele entender vh):
       --mob-card-h: calc(18vh);
    */
  }

  /* Destacado = 2 cards + gap */
  .featured-card-mobile {
    height: calc((var(--mob-card-h) * 2) + var(--mob-gap));
  }

  .featured-card-mobile .v-image,
  .featured-img {
    height: 100% !important;
  }

  /* Bloque derecho superior igual al destacado */
  .mobile-right-top {
    height: calc((var(--mob-card-h) * 2) + var(--mob-gap));
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  /* Cada botón del bloque superior = alto normal */
  .mobile-half {
    height: var(--mob-card-h);
    margin: 0 !important;
  }

  .mobile-half-img {
    height: 98% !important;
  }
}
</style>
